import React from "react";
import frame from "../assets/frame_white.png";

import Zoom from "react-reveal/Zoom";
import Button from "../components/Button";

import { Link, useLocation } from "react-router-dom";

export default function HomeCover() {
  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  let query = useQuery();

  return (
    <>
      <div className="container-cover">
        <Zoom left cascade>
          <div style={{ marginTop: 0 }}>
            <i
              className="far fa-gem"
              style={{
                color: "white",
                fontSize: 20,
                textShadow: "5px 5px 11px rgba(15,16,24,0.5)",
              }}
            ></i>

            <p
              className="garamond-font"
              style={{ textShadow: "5px 5px 11px rgba(15,16,24,1)" }}
            >
              The Wedding of
            </p>
            <p
              className="playball-font"
              style={{
                marginBottom: 5,
                textShadow: "5px 5px 11px rgba(15,16,24,1)",
              }}
            >
              Vita & Ganang
            </p>
            {/* <i
              className="garamond-font"
              style={{
                fontSize: 25,
                textShadow: "5px 5px 11px rgba(15,16,24,0.75)",
              }}
            >
              Sesi {query.get("huhu")}
            </i> */}

            <p
              className="garamond-font"
              style={{
                marginTop: 10,
                textShadow: "5px 5px 11px rgba(15,16,24,1)",
              }}
            >
              Sunday, January 30ᵗʰ 2022
            </p>
            <p
              className="garamond-font"
              style={{ textShadow: "5px 5px 11px rgba(15,16,24,1)" }}
            >
              Kepada Yth. {query.get("hihi")}
            </p>
          </div>
        </Zoom>
      </div>
      <div className="frame">
        <img src={frame} className="image-frame" />
      </div>
      <Link to={`/main?hihi=${query.get("hihi")}`}>
        <Button text="Buka Undangan" />
      </Link>
    </>
  );
}
